import { BASE_URL } from './Config';

export async function Call(endpoint: string, method: string, body?: any): Promise<any> {
  try {
    const uri = `${BASE_URL}${endpoint}`;
    const response = await fetch(uri, {
      method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: body ? JSON.stringify(body) : undefined
    });

    if (!response.ok) {
      // Gestisce errori di stato non OK
      const errorData = await response.json();
      if (errorData.message === 'Token non valido') {
        alert(errorData.message);
        localStorage.removeItem('authToken');
        localStorage.removeItem('userRole');
        localStorage.removeItem('userName');
        window.location.href = '/login';
      }
      console.error('Errore API lato server:', errorData);
      return new Response(JSON.stringify(errorData), {
        status: response.status,
        headers: { 'Content-Type': 'application/json' }
      });
    }

    return response;
  } catch (error) {
    console.error('Errore di rete:', error);
    return new Response(
      JSON.stringify({
        success: false,
        message: 'Errore interno del server o server non raggiungibile'
      }),
      {
        status: 500,
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }
}
